module.exports = __webpack_public_path__ + "img/box4_bg_dark.1e9e650c.png";